import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatData } from '../../interfaces/stat.interface';

@Component({
  selector: 'app-stats',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.scss']
})
export class StatsComponent {
  @Input() data!: StatData;
}
